import { render, staticRenderFns } from "./ClaimSources.vue?vue&type=template&id=2829e96b&"
import script from "./ClaimSources.vue?vue&type=script&lang=js&"
export * from "./ClaimSources.vue?vue&type=script&lang=js&"
import style0 from "./ClaimSources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports